"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smarttagsPropType = void 0;
const tslib_1 = require("tslib");
const PropTypes = tslib_1.__importStar(require("prop-types"));
const smarttagPropType = PropTypes.shape({
    key: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.string,
    })),
});
exports.smarttagsPropType = PropTypes.arrayOf(smarttagPropType);
